<template>
  <div class="keyscontroltext">
    <div class="utils">
      <el-input
        id="productIdSearch"
        v-model="productKeySearchVal"
        placeholder="Search"
        type="search"
        class="rightmargin inpstyle"
        data-cy="productkeys-input-search"
        v-if="showOptions"
      >
        <template #suffix>
          <img
            src="@/assets/icons/search.svg"
            style="width: 25px"
            alt="searchimg"
            title="searchimg"
          />
        </template>
      </el-input>
    </div>
  </div>
  <el-table
    id="productKeystable"
    v-loading="loading"
    :data="productKeyList"
    style="width: 100%"
    max-height="600px"
    scrollbar-always-on
    :header-cell-style="headerstyle"
    @sort-change="handleSorting"
    :row-style="rowdatastyle"
    :empty-text="nodatatxt"
    data-cy="productkeys-table"
  >
    <el-table-column label="Product Key" prop="productKey">
      <template #default="props">
        <div>{{ props.row.productKey }}</div>
      </template>
    </el-table-column>
    <el-table-column label="Product" prop="productName" sortable="custom">
      <template #default="props">
        <div>
          {{ props.row.productName }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="Type" prop="typeName" sortable="custom">
      <template #default="props">
        <div>
          {{ props.row.typeName }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="Status" prop="status" sortable="custom">
      <template #default="props">
        <div>
          {{ props.row.status }}
        </div>
      </template>
    </el-table-column>
    <el-table-column
      label="Expiration Date"
      align="center"
      prop="endDate"
      sortable="custom"
    >
      <template #default="props">
        <el-tooltip
          placement="top"
          v-if="checkExpirationDate(props.row.endDate)"
        >
          <template #content>
            <div v-if="expiringIn30Days">
              The license has expired or is about to expire shortly.
              <br />Please unassign the expired license and assign the new
              license.
            </div>
          </template>
          <div class="expiration-cell">
            {{ props.row.endDate }}
          </div>
        </el-tooltip>
        <div v-if="!checkExpirationDate(props.row.endDate)">
          {{ props.row.endDate }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="User" prop="lastname" sortable="custom">
      <template #default="props">
        <el-link
          type="primary"
          :underline="'never'"
          @click="viewUserDetails(props.row)"
          style="cursor: pointer"
          class="linkText"
          data-cy="productkeys-link-user"
        >
          {{ props.row.userName }}
        </el-link>
      </template>
    </el-table-column>
    <el-table-column label="Company" prop="companyName" sortable="custom">
      <template #default="props">
        <el-link
          type="primary"
          :underline="'never'"
          @click="viewCompanyDetails(props.row)"
          style="cursor: pointer"
          class="linkText"
          data-cy="productkeys-link-company"
        >
          {{ props.row.companyName }}
        </el-link>
      </template>
    </el-table-column>
  </el-table>
  <div class="pagingdiv" v-if="totalPages > 1" data-cy="productkeys-pagination">
    <label class="pagelabel"
      ><strong>Page {{ currentPage }} / {{ totalPages }}</strong></label
    >
    <el-button
      plain
      class="paginationbtn"
      @click="onPageChange(1)"
      id="firstpage"
      :disabled="currentPage === 1"
    >
      <img
        src="@/assets/icons/pagefirstenabled.svg"
        style="width: 20px"
        v-if="currentPage !== 1"
        alt="firstpageimg"
        title="firstpageimg"
      />
      <img
        src="@/assets/icons/pagefirstdisabled.svg"
        style="width: 20px"
        v-if="currentPage === 1"
        alt="firstpagedisabledimg"
        title="firstpagedisabledimg"
      />
    </el-button>
    <el-pagination
      layout="prev, next"
      :total="totalRowsCount"
      :page-size="5"
      v-model:current-page="currentPage"
      @current-change="onPageChange"
    />
    <el-button
      plain
      class="paginationbtn"
      @click="onPageChange(totalPages)"
      id="lastpage"
      :disabled="currentPage === totalPages"
    >
      <img
        src="@/assets/icons/pagelastenabled.svg"
        style="width: 20px"
        v-if="currentPage !== totalPages"
        alt="lastpageimg"
        title="lastpageimg"
      />
      <img
        src="@/assets/icons/pagelastdisabled.svg"
        style="width: 20px"
        v-if="currentPage === totalPages"
        alt="lastpagedisabledimg"
        title="lastpagedisabledimg"
      />
    </el-button>
  </div>
</template>
<style lang="scss">
.pagelabel {
  font-family: "Open Sans";
  margin: 10px 1rem;
}
.columnlabel {
  font-family: "Open Sans";
  font-weight: 300;
}
.keyscontroltext {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.pagingdiv {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
}
.utils {
  display: flex;
  flex-direction: row;
}
.page-item.active .page-link {
  z-index: 3;
  color: #ffffff;
  background-color: #ff5800;
  border-color: #ff5800;
  font-family: "Open Sans";
  font-weight: 700;
  display: none;
}
.marginright {
  margin-right: 0.5rem;
}
.headerFont {
  font-size: 1.5em;
  line-height: 1.73em;
}
.expirationlabel {
  color: #df444d;
  font-size: 14px;
  line-height: 1.53em;
  font-family: "Open Sans";
  font-weight: 400;
}
.linkText {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #ff5800;
  text-decoration: underline;
  text-decoration-thickness: 1.5px;
  margin-top: 20px;
  font-family: Arial, sans-serif;
}
</style>
<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import _ from "lodash";
import APIService from "@/utils/APIService";
import { ProductActionTypes } from "@/store/productstore/ProductActionTypes";
import { CompanyActionTypes } from "@/store/companystore/CompanyActionTypes";
import { FlowActionTypes } from "@/store/flowstore/FlowActionTypes";
import { AuthActionTypes } from "@/store/authstore/AuthActionTypes";
import { ProductKeySearchQuery } from "@/utils/AppInterfaces";

enum sortingField {
  lastname = 0,
  userName = 1,
  status = 4,
  companyName = 11,
  productName = 21,
  expirationDate = 24,
  licenseType = 25,
}

export default defineComponent({
  name: "ProductKeysOverview",
  components: {},
  computed: {
    ...mapGetters(["getProductKeyEntitlements", "getCurrentUser"]),
    productKeyList(): any {
      if (!_.isEmpty(this.getProductKeyEntitlements)) {
        this.updatePaginationData();
      } else if (!_.isEmpty(this.getCurrentUser)) {
        this.init();
      }
      return this.getProductKeyEntitlements.items;
    },
    productKeySearchVal: {
      get(): string {
        return this.productKeySearchText;
      },
      set(val: string) {
        this.productKeySearchText = val;
      },
    },
    showOptions(): boolean {
      return !!(
        !_.isEmpty(this.getProductKeyEntitlements) ||
        this.productKeySearchText !== ""
      );
    },
  },
  data() {
    return {
      nodatatxt: "No product keys available",
      headerstyle: {
        "border-bottom": "unset",
        background: "#F2F2F2",
        "font-family": "Open Sans, sans-serif",
        "font-weight": "700",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      rowdatastyle: {
        "font-family": "Open Sans, sans-serif",
        "font-weight": "400",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      totalRows: 1,
      perPage: 10,
      currentPage: 1,
      pagesNumber: 1,
      totalPages: 0,
      totalRowsCount: 0,
      itemsOnPage: 0,
      productKeySearchText: "",
      loading: true,
      selected: [],
      sortingField: 0,
      sortOrder: 0,
      expiringIn30Days: false,
    };
  },
  watch: {
    productKeySearchText(val) {
      this.currentPage = 1;
      const productKeyDataObj: ProductKeySearchQuery = {
        searchPhrase: this.productKeySearchText,
        pageOptions: {
          skip: 0,
          take: 10,
          sortField: this.sortingField,
          sortOrder: this.sortOrder,
        },
      };
      if (val.length !== 0) {
        this.checkSearchStr(productKeyDataObj);
      } else {
        this.fetchProductkeys(productKeyDataObj);
      }
    },
  },
  methods: {
    checkSearchStr: _.debounce(function (this: any, productKeyDataObj: any) {
      this.fetchProductkeys(productKeyDataObj);
    }, 1000),
    init() {
      const productKeyDataObj: ProductKeySearchQuery = {
        searchPhrase: this.productKeySearchText,
        pageOptions: {
          skip: 0,
          take: 10,
          sortField: this.sortingField,
          sortOrder: this.sortOrder,
        },
      };
      this.fetchProductkeys(productKeyDataObj);
    },
    updatePaginationData() {
      this.currentPage =
        this.currentPage !== 0
          ? this.currentPage
          : this.getProductKeyEntitlements.pagingData.currentPage;
      this.totalPages = this.getProductKeyEntitlements.pagingData.totalPages;
      this.totalRowsCount = this.getProductKeyEntitlements.pagingData.itemCount;
    },
    onPageChange(currPage: number) {
      this.currentPage = currPage;
      this.loading = true;
      const productKeyDataObj: ProductKeySearchQuery = {
        searchPhrase: this.productKeySearchText,
        pageOptions: {
          skip: currPage - 1,
          take: 10,
          sortField: this.sortingField,
          sortOrder: this.sortOrder,
        },
      };
      this.fetchProductkeys(productKeyDataObj);
      this.selected = [];
    },
    handleSorting({ prop, order }: { prop: any; order: any }) {
      this.sortingField =
        prop === "companyName"
          ? sortingField.companyName
          : prop === "productName"
          ? sortingField.productName
          : prop === "endDate"
          ? sortingField.expirationDate
          : prop === "typeName"
          ? sortingField.licenseType
          : prop === "status"
          ? sortingField.status
          : prop === "lastname"
          ? sortingField.userName
          : 0;
      this.sortOrder = order === "ascending" ? 0 : 1;
      const productKeyDataObj: ProductKeySearchQuery = {
        searchPhrase: this.productKeySearchText,
        pageOptions: {
          skip: 0,
          take: 10,
          sortField: this.sortingField,
          sortOrder: this.sortOrder,
        },
      };
      this.fetchProductkeys(productKeyDataObj);
      this.currentPage = 1;
    },
    checkExpirationDate(expiringDate: any) {
      const expirationDate = new Date(expiringDate);
      const dateIn30Days = new Date();

      // Add 30 days correctly
      dateIn30Days.setDate(dateIn30Days.getDate() + 30);

      if (expirationDate.getTime() <= dateIn30Days.getTime()) {
        return (this.expiringIn30Days = true);
      }

      return false;
    },
    viewCompanyDetails(row: any) {
      var company = {
        companyBucketId: row.companyBucketId,
        companyName: row.companyName,
      };
      this.$store.dispatch(CompanyActionTypes.SET_COMPANY_DATA, company);
    },
    viewUserDetails(row: any) {
      this.fetchUserData(row);
    },
    fetchProductkeys(productKeyDataObj: any) {
      this.loading = true;
      const apiService = new APIService(this.axios);
      apiService
        .getProductKeyEntitlements(productKeyDataObj)
        .then((res) => {
          this.loading = false;
          this.$store.dispatch(ProductActionTypes.SET_PRODUCT_KEYS, res);
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
    fetchUserData(row: any) {
      this.loading = true;
      const apiService = new APIService(this.axios);
      const userDataObj = {
        userBucketIdList: [row.userBucketId],
        companyBucketIdList: [row.companyBucketId],
        searchPhrase: row.lastName,
        companyName: null,
        pageOptions: {
          skip: 0,
          take: 1,
          sortField: 999,
          sortOrder: 0,
        },
      };
      apiService
        .getUsersList(userDataObj)
        .then((res) => {
          const returnedUser = res.items[0];
          var user: any = {
            userBucketId: row.userBucketId,
            firstName: returnedUser.firstName,
            lastName: returnedUser.lastName,
            email: returnedUser.email,
            companyName: returnedUser.companyName,
            userStatus: returnedUser.userStatus,
          };
          this.loading = false;
          this.$store.dispatch(FlowActionTypes.SET_USER_DATA, user);
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
  },
});
</script>
